import { styled } from "@mui/material";

export const WorkpagesContainer = styled('div')({
    display: "flex",
    flexDirection: "column",
    width: "684px",
});